import axiosInstance from '@/axiosInstance.js';
import pinia from '@/store.js';
import { defineStore } from "pinia";

export const useAuthStore = defineStore('AuthStore', {
    state: () => ({
        token: null,
        user: '',
        error: null,
        successmsg: null,
        passwordtoken: null,
    }),
    getters: {
        authenticated (state) {
            return (this.token && this.user != '') ? true : false;
        },
    },
    actions: {
        async signIn (credentials) {
            let response = await axiosInstance.post('auth/signin', credentials);
            if(response && response.data.errormsg) {
                this.error = response.data.errormsg;
                this.token = null;
                return false;

            }

            if (response.data.user) {
                this.error = null;
                this.user = response.data.user;
                console.log('this.user: ', this.user);

            } else if(response.data.includes('Site Down')) {
                this.error = 'Site is getting updated, check back soon.';
                this.token = null;
                return false;
            }
            // assumed to be present
            this.token = [response.data.access_token];

            return true;


        },

        async attempt () {
            // headers with token set in router index.js
            let params;
            if(! this.user || this.user == '' || typeof this.user == 'undefined') {
                params = {
                    need_user_data: true
                };
            } else {
                params = {};
            }
            let response = await axiosInstance.post('auth/me', params);
            if(response.data.errormsg) {
                console.log(response.data.errormsg)
                this.token = null;
                this.error = response.data.errormsg;
                localStorage.removeItem('token');
                return false;

            } else {
              // access token is stored via router index.js
                this.error = null;
                if(response.data.user) {
                    this.user = response.data.user;
                    console.log('this.user: ', this.user);
                }

                return true;

            }
        },

        async signOut () {
            this.user = '';
            this.token = null;
            this.error = null;
            this.passwordtoken = null;
            localStorage.setItem('token', null);
            localStorage.removeItem('token');
            return true;
        },

    }
});
